import _ from "lodash";
import { Action, Reducer } from "redux";
import { AppThunkAction } from "../ApplicationStore";

export interface ErrorMessage {
  error: string;
  data?: any;
}

export interface NotificationsState {
  errors: ErrorMessage[];
}

interface AddErrorsAction {
  type: "ADD_ERRORS";
  errors: ErrorMessage[];
}

interface RemoveErrorsAction {
  type: "REMOVE_ERRORS";
  errors: string[];
}

type KnownAction = AddErrorsAction | RemoveErrorsAction;

export const actionCreators = {
  addNotifications:
    (errors: string[], data?: any): AppThunkAction<KnownAction> =>
    (dispatch) => {
      var errorMessages = errors.map((error) => ({
        error,
        data,
      }));
      dispatch({ type: "ADD_ERRORS", errors: errorMessages });
    },
  removeNotifications:
    (errors: string[]): AppThunkAction<KnownAction> =>
    (dispatch) =>
      dispatch({ type: "REMOVE_ERRORS", errors }),
};

const unloadedState = {
  errors: [],
};

export const reducer: Reducer<NotificationsState> = (
  state: NotificationsState = unloadedState,
  incomingAction: Action
) => {
  const action = incomingAction as KnownAction;

  switch (action.type) {
    case "ADD_ERRORS":
      return {
        ...state,
        errors: state.errors.concat(...action.errors),
      };
    case "REMOVE_ERRORS":
      return {
        ...state,
        errors: state.errors.filter((errorMessage) => !_.includes(action.errors, errorMessage.error)),
      };
    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      // eslint-disable-next-line
      const exhaustiveCheck: never = action;
  }
  return state;
};
